import * as echarts from "echarts";
// import ChainMapData from "../data/china.json";

// echarts.registerMap("china", ChainMapData);

function echartsHook(el) {
  const echartsInstance = echarts.init(el);

  const setOption = (option) => {
    echartsInstance.setOption(option);
  };

  const setResize = () => {
    echartsInstance.resize();
  };

  window.addEventListener("resize", () => {
    echartsInstance.resize();
  });

  return {
    setOption,
    setResize,
  };
}

export default echartsHook;